import { Dropdown } from "react-bootstrap";
import { Checkbox } from "@mui/material";
import CustomButton from "./button";
import plus from '../assets/images/plus.svg'
import { useContext, useEffect, useState } from "react";
import { Record } from "react-bootstrap-icons";
import { PostCallWithErrorResponse } from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import { toastMsg } from "./toast";
import { AppContext } from "../context/AppContext";

const MultipleSelectCheckmarks = ({ options = [], seletedRecord, code, getList, setSelectsRec, getTags }) => {

    const { adminData } = useContext(AppContext)

    const [selectedTags, setSelectedTags] = useState({})

    const [tagName, setTagName] = useState('')



    const handleSelected = () => {


        let obj = {}

        seletedRecord?.forEach(record => {

            record?.tags?.forEach((tag) => {

                if (obj.hasOwnProperty(tag.status)) {
                    obj[tag.status] = obj[tag.status] + 1
                } else {
                    obj[tag.status] = 1
                }

            })

        });

        setSelectedTags(obj)


    }

    const handleSelectTag = (isChecked, tag) => {

        if (!seletedRecord?.length) {
            toastMsg('error', "Please Select Candidates !")

            return
        }


        let obj = { ...selectedTags }

        if (isChecked) {

            obj[tag] = seletedRecord?.length
        } else {

            delete obj[tag]

        }

        setSelectedTags(obj)

        let payload = {
            "code": code,
            "tag": tag,
            "isAdd": isChecked,
            "userIds": seletedRecord?.map((i) => i?.userId),
            admin: adminData?.email
        }

        PostCallWithErrorResponse(ApiConfig.UPDATE_TAGS, payload)
    }


    useEffect(() => {
        handleSelected()
    }, [seletedRecord])


    const addTags = () => {

        let tagN = tagName.trim()

        if (!tagN) {

            toastMsg('error', 'Please Enter Tag Name !')

            return
        }

        let isExist = options?.some((tag) => tag?.name?.toLowerCase() === tagN?.toLowerCase())

        if (isExist) {

            toastMsg('error', 'Tag Name Already Exist!')
            return
        }


        let payload = {
            "code": code,
            "tagName": tagN
        }

        PostCallWithErrorResponse(ApiConfig.ADD_CUSTOM_TAG, payload).then((res) => {

            if (res?.json?.response?.status) {
                getTags()
                toastMsg('success', res?.json?.response?.statusMessage)
                setTagName('')

                return
            }

            toastMsg('error', res?.json?.response?.statusMessage)


        })


    }


    return (
        <Dropdown

            onToggle={(isOpen) => {
                if (!isOpen) {

                    getList(code);

                    setSelectedTags({})

                    setSelectsRec([])
                }
            }}
        >
            <Dropdown.Toggle
                variant="light"
                className="w-100 d-flex justify-content-between align-items-center"
                style={{
                    maxWidth: "229px",
                    height: "33px",
                    fontSize: "12px",
                    background: "transparent",
                    border: "1px solid #ced4da",
                    color: "#000",
                }}
            >
                {Object.keys(selectedTags).length ? Object.keys(selectedTags)?.slice(0, 2).join(", ") : "Set Tags"}

            </Dropdown.Toggle>

            <Dropdown.Menu style={{ padding: "5px", width: "229px" }}>
                {options.map((tag, idx) => (
                    <div key={idx} className="d-flex align-items-center" style={{ cursor: "pointer" }}
                        onClick={() => handleSelectTag(
                            !(selectedTags[tag?.name] === seletedRecord?.length),
                            tag?.name
                        )}

                    >
                        <Checkbox
                            // size="small"
                            style={{ padding: '0px', height: '5px' }}
                            checked={selectedTags[tag?.name] === seletedRecord?.length}
                            indeterminate={selectedTags.hasOwnProperty(tag?.name) && selectedTags[tag?.name] != seletedRecord?.length}
                            // onClick={(e) => e.stopPropagation()}
                            onChange={(e) => handleSelectTag(e.target.checked, tag?.name)}
                            sx={{
                                transform: "scale(0.6)",     // Reduce checkbox size
                                padding: "0px",
                            }}
                        />
                        <span style={{ fontSize: '12px' }}>{tag?.name}</span>
                    </div>
                ))}
                <div className="d-flex gap-1 mt-2">
                    <input
                        value={tagName}
                        onChange={(e) => setTagName(e.target.value)}
                        type="text" style={{ width: '160px', height: '30px' }}
                        className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
                    />
                    <img src={plus} style={{ height: '20px', width: '20px', cursor: 'pointer', marginTop: '4px', marginLeft: '4px' }}
                        onClick={addTags}
                    />
                </div>

            </Dropdown.Menu>
        </Dropdown>
    );
};

export default MultipleSelectCheckmarks;
